<app-spinner-overlay></app-spinner-overlay>

<h2 mat-dialog-title>Attivazioni</h2>

<div class="sottotitolo">
  Imposta i parametri di selezione ed esegui per ottenere le attivazioni del periodo
</div>

<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formParametri" appFormContainer [larghezza]="6" class="form-parametri">
    <mat-radio-group
      formControlName="modalitaPeriodo"
      appFormElement
      [larghezza]="2"
      [riempi]="true"
    >
      <mat-radio-button value="anno">Anno</mat-radio-button>
      <mat-radio-button value="intervallo">Intervallo date</mat-radio-button>
    </mat-radio-group>

    @if (formParametri.get('modalitaPeriodo')?.value === 'anno') {
      <mat-form-field appFormElement [larghezza]="1.5" [riempi]="true">
        <mat-label>Anno</mat-label>
        <mat-select formControlName="anno" placeholder="Anno">
          <mat-option *ngFor="let anno of anni" [value]="anno">{{ anno }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>
    } @else {
      <mat-form-field appFormElement [larghezza]="1.5" [riempi]="true">
        <mat-label>Attivazioni dal</mat-label>
        <input matInput [matDatepicker]="pickerDataDa" formControlName="dataDa" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerDataDa"></mat-datepicker-toggle>
        <mat-datepicker #pickerDataDa></mat-datepicker>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field appFormElement [larghezza]="1.5" [riempi]="true">
        <mat-label>Attivazioni al</mat-label>
        <input matInput [matDatepicker]="pickerDataA" formControlName="dataA" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerDataA"></mat-datepicker-toggle>
        <mat-datepicker #pickerDataA></mat-datepicker>
        <mat-error appFormError></mat-error>
      </mat-form-field>
    }

    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Codice promotore</mat-label>
      <mat-select formControlName="codicePromotore" placeholder="Tutti">
        <mat-option [value]="null">Tutti</mat-option>
        <mat-option *ngFor="let promotore of promotori" [value]="promotore.codice">
          {{ promotore.codice }} - {{ promotore.descrizione }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Ruolo</mat-label>
      <mat-select formControlName="ruolo" placeholder="Tutti">
        <mat-option [value]="null">Tutti</mat-option>
        <mat-option *ngFor="let ruolo of ruoli" [value]="ruolo.roleName">
          {{ ruolo.descrizione }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appFormElement [larghezza]="1.5" [riempi]="true">
      <mat-label>Tipo rinnovo</mat-label>
      <mat-select formControlName="tipoRinnovo" placeholder="Tutti">
        <mat-option [value]="null">Tutti</mat-option>
        <mat-option value="AUTOMATICO">Automatico</mat-option>
        <mat-option value="MANUALE">Manuale</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="cont-bottoni-parametri">
    <button mat-flat-button color="primary" class="primary-button" (click)="esegui()">
      <mat-icon>play_arrow</mat-icon>
      Esegui
    </button>
    <button
      mat-flat-button
      color="accent"
      class="accent-button"
      (click)="esporta()"
      [disabled]="!isEseguito"
    >
      Esporta
      <mat-icon>file_download</mat-icon>
    </button>
  </div>

  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [isFiltri]="false"
    [maxNrButton]="1"
    [defaultPageSize]="20"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
  </app-lista-tabellare>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
</div>
